import Service from "../../../api/api-service";
import { ApiUrl } from "../../../api/api-url";
import * as config from "../../../common/config"

const service = new Service();

export const GetListAll = (pageIndex = 1, pageSize = config.Configs.DefaultPageSize, sortExpression = "modifiedDate desc",title="",placeKindId,placeTypeId) => {
    const params = new URLSearchParams();
    params.append('pageIndex',pageIndex);
    params.append('pageSize',pageSize);
    params.append('sorting',sortExpression);
    placeKindId && params.append('placeKindId',placeKindId);
    placeTypeId && params.append('placeTypeId',placeTypeId);
    title && params.append('title',title);
    return service.get(ApiUrl.Place_GetListAll,params).then(res => { return res }).catch(err => { throw err });
}

export const GetDetail = (id) => {
    const params = new URLSearchParams();
    params.append("id", id);
    return service.get(ApiUrl.Place_GetDetail.replace("{id}",id)).then(res => { return res }).catch(err => { throw err });
}

export const Create = (body) => {
    return service.post(ApiUrl.Place_Create, body).then(res => { return res }).catch(err => { throw err });
}

export const Update = (body) => {
    return service.post(ApiUrl.Place_Update, body).then(res => { return res }).catch(err => { throw err });
}

export const Delete = (id) => {
    return service.postParams(ApiUrl.Place_Delete + "/" + id ).then(res => { return res }).catch(err => { throw err });
}
